/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CoursesList } from '../../models/courses-list';
import { MassSelection } from '../../models/mass-selection';

export interface ApiStudentCoursesListPost$Params {
      body: MassSelection
}

export function apiStudentCoursesListPost(http: HttpClient, rootUrl: string, params: ApiStudentCoursesListPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CoursesList>> {
  const rb = new RequestBuilder(rootUrl, apiStudentCoursesListPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CoursesList>;
    })
  );
}

apiStudentCoursesListPost.PATH = '/api/student/courses/list';
